module.exports = __webpack_public_path__ + "static/img/Washroom-Branding.35ad8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Washroom-Branding.jpg
// module id = uGVG
// module chunks = 11